// Modernizr Touch Events Test
document.addEventListener('DOMContentLoaded', function() {
  console.log('Modernizr Touch Events Test');
  console.log('=========================');
  
  // Check if Modernizr is loaded
  if (typeof Modernizr !== 'undefined') {
    console.log('✓ Modernizr is loaded');
    
    // Check touchevents detection
    console.log('Touch events supported:', Modernizr.touchevents);
    
    // Check HTML classes
    const htmlClasses = document.documentElement.className;
    console.log('HTML classes:', htmlClasses);
    
    // Show device capabilities
    if (Modernizr.touchevents) {
      console.log('📱 This device supports touch events');
    } else {
      console.log('🖱️ This device does not support touch events');
    }
  } else {
    console.error('✗ Modernizr is not loaded');
  }
});